import { render, staticRenderFns } from "./tiscModal.vue?vue&type=template&id=ba81ccce&"
import script from "./tiscModal.vue?vue&type=script&lang=js&"
export * from "./tiscModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports